import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  highlighted?: boolean;
}
export function Card({
  children,
  className = '',
  delay = 0,
  highlighted = false
}: CardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 15
  }} animate={{
    opacity: 1,
    y: 0,
    boxShadow: highlighted ? '0 0 0 2px rgba(196, 18, 48, 0.5), 0 0 20px rgba(196, 18, 48, 0.1)' : '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
  }} transition={{
    duration: 0.5,
    delay: highlighted ? 0 : delay,
    ease: 'easeOut',
    boxShadow: {
      duration: 0.3
    }
  }} className={`bg-white border-l-[3px] rounded-r-xl rounded-l-sm p-6 md:p-8 transition-colors duration-300 ${highlighted ? 'border-l-crimson bg-crimson-light/30' : 'border-l-crimson'} ${className}`} data-id="element-385">
      {children}
    </motion.div>;
}